import { Role } from '#/entity';

const STATIC_LABEL_KEYS: Record<string, string> = {
  Device: 'sys.device.device',
  Devices: 'sys.device.devices',
  Movies: 'sys.movies.movies',
  Series: 'sys.series.series',
};

export const getNavigationLabel = (
  label: string,
  t: (key: string) => string,
  role?: string,
  exists?: (key: string) => boolean,
) => {
  if (!label) return '';

  if (role === Role.PropertyAdmin && label === 'sys.menu.system.properties') {
    return 'Bundle';
  }

  const translationKey = STATIC_LABEL_KEYS[label] || label;
  if (exists && !exists(translationKey)) return label;

  const translated = t(translationKey);
  return translated === translationKey ? label : translated;
};
